// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-metrics[data-v-32cf20dd] .external-link{position:absolute;left:200px;top:-45px}.dashboard-metrics[data-v-32cf20dd] .frame{top:0}.dashboard-metrics.external-link-pull-left[data-v-32cf20dd] .external-link{position:absolute;left:10px;top:-47px}", ""]);
// Exports
module.exports = exports;
